const Last = require('lodash/last');
const { useEffect, useRef } = require('react');

exports.useChatReadReceipts = function useChatReadReceipts(props) {

    const {
        announcementConversation,
        currentUserId,
        dependenciesReady,
        isAnnouncement,
        messages,
        onSetAnnouncementLastReadMessageIndex,
        onSetLastReadMessageIndex,
        setLastReadMessageIndexByConversationSid,
        sid
    } = props;

    const lastMessage = Last(messages);
    const lastMessageIndex = lastMessage?.index;
    const lastMessageUserId = lastMessage?.user?.id;
    const lastSubmittedReceiptRef = useRef({
        conversationKey: null,
        messageIndex: null
    });

    useEffect(() => {

        if (!dependenciesReady) {
            return;
        }

        if (typeof lastMessageIndex === 'undefined' || lastMessageUserId === currentUserId) {
            return;
        }

        if (isAnnouncement) {
            if (!announcementConversation) {
                return;
            }
        }

        const conversationKey = isAnnouncement
            ? `announcement:${announcementConversation.id}`
            : `twilio:${sid}`;

        const lastSubmittedReceipt = lastSubmittedReceiptRef.current;

        // Redux updates may recreate callback props without advancing the chat. Keep
        // the receipt monotonic so those rerenders do not repeat Twilio and API writes.
        if (lastSubmittedReceipt.conversationKey === conversationKey &&
                lastSubmittedReceipt.messageIndex >= lastMessageIndex) {
            return;
        }

        lastSubmittedReceiptRef.current = {
            conversationKey,
            messageIndex: lastMessageIndex
        };

        if (isAnnouncement) {
            onSetAnnouncementLastReadMessageIndex({
                conversationId: announcementConversation.id.toString()
            });

            return;
        }

        onSetLastReadMessageIndex({
            messageIndex: lastMessageIndex
        });
        setLastReadMessageIndexByConversationSid({
            conversationSid: sid,
            messageIndex: lastMessageIndex
        });
    }, [
        announcementConversation,
        currentUserId,
        dependenciesReady,
        isAnnouncement,
        lastMessageIndex,
        lastMessageUserId,
        onSetAnnouncementLastReadMessageIndex,
        onSetLastReadMessageIndex,
        setLastReadMessageIndexByConversationSid,
        sid
    ]);
};
